import React, { memo, useCallback, useMemo } from 'react';
import { WithErrorHandler } from '../../components/WithErrorHandler';
var Index = function (props) {
    var successRelate = useMemo(function () { return props.successRelate; }, [props.successRelate]);
    var onClickClose = useCallback(function () {
        if (typeof props.onClickClose !== 'undefined') {
            props.onClickClose();
        }
    }, []);
    return React.createElement("div", { className: 'newcar-askcontent-success' },
        successRelate && successRelate.showSuccessIcon && React.createElement("img", { src: "//icon.xgo-img.com.cn/topic/22010517/secuss.png", className: 'success-icon', alt: "" }),
        successRelate.successTitle && React.createElement("div", { className: 'success-title' }, successRelate.successTitle),
        successRelate.successSubTitle && (typeof successRelate.successSubTitle === 'string' ? React.createElement("div", { className: 'success-subtitle', dangerouslySetInnerHTML: { __html: successRelate.successSubTitle } }) : successRelate.successSubTitle),
        props.successRelate && props.successRelate.successMidSlot ?
            props.successRelate.successMidSlot : React.createElement(React.Fragment, null),
        successRelate.successBtnTitle && React.createElement("div", { className: 'success-btn', onClick: onClickClose }, successRelate.successBtnTitle));
};
export default WithErrorHandler(memo(Index));
